// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item-group fieldset[data-v-1b96fa60] {\n  min-height: 500px;\n  width: 350px;\n}\n.red-border[data-v-1b96fa60] .el-input__inner,\n.red-border[data-v-1b96fa60] .el-textarea__inner,\n.red-border[data-v-1b96fa60] .cargo-rich-textarea {\n  border: 1px solid red !important;\n}\n", ""]);
// Exports
module.exports = exports;
